//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

const getStats = ()=>{
    return axios.get(API_URL+"/dashboards");
}
const getMoreState = ()=>{

}

export default {
    getStats,
    getMoreState
}